module.exports = __webpack_public_path__ + "static/media/MWM.818e6793.png";